import React from 'react';
export function Title() {
  return <h1 className="text-3xl md:text-4xl font-bold text-red-600 text-center uppercase mb-12" data-id="element-784">
      Returns & Refunds Policy
    </h1>;
}